import { render, staticRenderFns } from "./wheel3.vue?vue&type=template&id=54bd595e&"
import script from "./wheel3.vue?vue&type=script&lang=js&"
export * from "./wheel3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports